import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { differenceInDays } from "date-fns";
// prime react
import { Button } from "primereact/button";
//pages
import { HeaderDownloadParcelToPay } from "./HeaderDownloadParcelToPay";
// components
import Panel from "../../../../components/panel/panel";
import Input from "../../../../components/input/Input";
import Select from "../../../../components/input/Select";
import NumberInput from "../../../../components/input/NumberInput";
import CalendarInput from "../../../../components/input/CalendarInput";
import TextareaInput from "../../../../components/input/TextareaInput";
import FileInput from "../../../../components/input/FileInput";
//utils
import { formatYearDate } from "../../../../utils/formatDate";
import { formatCurrency } from "../../../../utils/formatCurrency";
//hooks
import usePermission from "../../../../hooks/usePermission";
import { useOptionsSelect } from "../../../../hooks/useOptionsSelect";
//services
//context
import { useFinancialContext } from "../../../../context/FinancialContext";
import { patchAccountToPayPayment } from "../../../../services/Financial/AccountToPay/patchAccountToPayPayment";

const DownloadParcelToPay = () => {
  usePermission("114"); //Baixar Parcelas
  const navigate = useNavigate();
  const {
    paymentMethod,
    loadingPaymentMethods,
    currentAccount,
    loadingCurrentAccount,
  } = useOptionsSelect();
  const { selectedCustomers, setSelectedCustomers } = useFinancialContext();

  const [loading, setLoading] = useState(false);
  const [firstDate, setFirstDate] = useState(null);
  const [firstId, setFirstId] = useState(null);
  const [paymentDates, setPaymentDates] = useState({});
  const [document, setDocument] = useState("");
  const [sum, setSum] = useState(0);
  const [totalParcel, setTotalParcel] = useState(0);
  const [totals, setTotals] = useState({
    updated_value: 0,
    discount: 0,
    add: 0,
  });

  const form = useForm();
  const errors = form.formState.errors;

  //Função para calcular e atualizar o "Valor Atualizado"
  function updateUpdatedValue(selected) {
    const fieldsToSum = ["value", "discount", "add"];
    const fieldsToSumValue = ["value", "discount", "add", "updated_value"];
    let objValue = {
      value: 0,
      discount: 0,
      add: 0,
      updated_value: 0,
    };
    const newValue = fieldsToSum.reduce((acc, field) => {
      const fieldName = `${field}_id_${selected.id}`;
      const fieldValue = parseFloat(form.getValues(fieldName)) || 0;
      let response = 0;
      if (field === "discount") {
        response = acc - fieldValue;
      } else {
        response = acc + fieldValue;
      }
      return response;
    }, 0);
    form.setValue(`updated_value_id_${selected.id}`, newValue.toFixed(2));

    for (let parcela of selectedCustomers) {
      for (let field of fieldsToSumValue) {
        const fieldName = `${field}_id_${parcela.id}`;
        const fieldValue = parseFloat(form.getValues(fieldName)) || 0;

        objValue[field] += fieldValue; // Soma os valores ao objeto de valores atualizados
      }
    }
    setTotals(objValue);
  }
  // updated payment-method in all parcels selected
  function updatedPayments(value) {
    for (const selected of selectedCustomers) {
      form.setValue(`payment_method_${selected.id}`, value);
    }
  }
  // updated current-account in all parcels selected
  function updatedCurrentAccount(value) {
    for (const selected of selectedCustomers) {
      form.setValue(`current_account_${selected.id}`, value);
    }
  }
  // updated payment-date to due_date in all parcels selected
  function handleDateParcel() {
    for (const selected of selectedCustomers) {
      const dueDate = new Date(selected.due_date);
      dueDate.setDate(dueDate.getDate() + 1);
      const today = new Date();
      dueDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      const finalDueDate = dueDate > today ? today : dueDate;
      const newDueDate = new Date(finalDueDate);
      newDueDate.setDate(finalDueDate.getDate());
      form.setValue(`payment_date_${selected.id}`, newDueDate);
    }
  }

  function handleDatePayment() {
    const newFirstDate = form.getValues(`payment_date_${firstId}`) || firstDate;
    if (newFirstDate) {
      const newDueDate = new Date(newFirstDate);
      for (const selected of selectedCustomers) {
        form.setValue(`payment_date_${selected.id}`, newDueDate);
      }
    } else {
      toast.warning("Informe a data da primeira parcela!");
    }
  }
  function handlePaymentDate(value, item) {
    const newDueDate = new Date(value);
    form.setValue(`payment_date_${item.id}`, newDueDate);
    if (item.id == firstId) {
      setFirstDate(newDueDate);
    }
  }
  // Função para extrair informações para cada ID
  function extrairInformacoes(objeto, id) {
    const item = {};
    item.id = id;
    item.daily_interest_rate = parseFloat(objeto[`fees_id_${id}`]) || 0;
    item.discount = objeto[`discount_id_${id}`];
    item.payment_value =
      (objeto[`value_id_${id}`] || 0) -
      (objeto[`discount_id_${id}`] || 0) +
      (objeto[`add_id_${id}`] || 0);
    item.payment_method_id = objeto[`payment_method_${id}`];
    item.payment_date = formatYearDate(objeto[`payment_date_${id}`]);
    item.current_account_id = objeto[`current_account_${id}`];
    item.completed_obs = objeto[`obs_id_${id}`] || "";
    item.addition = objeto[`add_id_${id}`];
    return item;
  }

  const onSubmit = async (data) => {
    setLoading(true);
    var hasNegativeValue = false;
    const objetosSeparados = [];

    for (const key in data) {
      if (key.startsWith("value_id")) {
        const id = parseInt(key.split("_")[2]);
        const existingItem = objetosSeparados.find((item) => item.id === id);
        if (!isNaN(id) && !existingItem) {
          const installment = extrairInformacoes(data, id);

           // Só adiciona o documento se ele existir
           if (document) {
            installment.document = {
              name: document?.name || "Documento de pagamento",
                desc: "Documento referente ao pagamento",
                file: document,
            };
        }


          objetosSeparados.push(installment);

          const updatedValueKey = `updated_value_id_${id}`;
          const updatedValue = parseFloat(data[updatedValueKey]);

          if (updatedValue < 0) {
            hasNegativeValue = true;
            setLoading(false);
          }
        }
      }
    }

    if (hasNegativeValue) {
      return toast.warning("O valor pago deve ser maior que R$ 0,00.");
    }

    const objToSend = {
      installments: objetosSeparados,
      ...(selectedCustomers[0]?.enterprise?.id && { enterprise_id: selectedCustomers[0].enterprise.id }),
    };

    // console.log("Payload enviado:", JSON.stringify(objToSend, null, 2)); // Verifique o Payload antes de enviar

    try {
      const response = await patchAccountToPayPayment(objToSend);
      toast.success(response.success);
      setSelectedCustomers(null);
      navigate("/financial/accountToPay");
    } catch (error) {
      if (
        error.response.data.error ===
        "Empreendimento sem conta bancaria cadastrada."
      ) {
        toast.error(error.response.data.error);
        return;
      } else if (error?.response?.data?.error["installments.0.payment_date"]) {
        const message =
          error?.response?.data?.error["installments.0.payment_date"];
        toast.error(message);
      } else {
        toast.error(error.response.data.error);
      }
    } finally {
      setLoading(false);
    }
  };

  // calc
  useEffect(() => {
    if (selectedCustomers && selectedCustomers.length > 0) {
      setFirstId(selectedCustomers[0].id);
      let cont = 0;
      let totalParcels = 0;
      let saveTotal = 0;
      let discount = 0;
      let add = 0;

      selectedCustomers?.forEach((selected) => {
        cont++; // sum quantity parcels selected
        totalParcels += selected.value;
        form.setValue(`value_id_${selected.id}`, selected.value);

        const dueDate = new Date(selected.due_date);
        const defaultDate = paymentDates[selected.id] || new Date(); // Usa a data de pagamento do item ou a data atual
        const daysPassed = differenceInDays(defaultDate, dueDate);

        const newDueDate = new Date(dueDate);
        newDueDate.setDate(dueDate.getDate() + 1);
        form.setValue(`due_date_id_${selected.id}`, newDueDate);
        form.setValue(`amount_id_${selected.id}`, daysPassed);

        const valorParcela = selected.value;
        discount += selected.discount;
        add += selected.discount;

        const total = add + valorParcela - discount;
        saveTotal += total;

        form.setValue(`updated_value_id_${selected.id}`, total.toFixed(2));
      });

      setSum(cont);
      setTotalParcel(totalParcels);
      setTotals({
        updated_value: saveTotal,
        add: add,
        discount: discount,
      });
    }
  }, [selectedCustomers, paymentDates]); // Observa o objeto paymentDates

  return (
    <div className="row d-flex justify-content-center mb-3">
      <HeaderDownloadParcelToPay
        updatedPayments={updatedPayments}
        updatedCurrentAccount={updatedCurrentAccount}
        handleDateParcel={handleDateParcel}
        handleDatePayment={handleDatePayment}
      />
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div style={{ maxHeight: "55vh", overflowY: "scroll" }}>
          {selectedCustomers?.map((item, index) => (
            <Panel key={index} mainCss="my-2" style={{ minHeight: "300px", height: "auto" }}>
              <h5>
                Parcela: {item?.sequence_number} - {item?.client_name} -{" "}
                {item?.description?.name} - {item?.enterprise?.title} -{" "}
                {item?.block}{" "}
              </h5>
              <hr className="my-3" />

              <div className="row">
                <div className="row">
                  <div className="col-md-6">
                    {" "}
                    <Input
                      control={form.control}
                      disabled={true}
                      defaultValue={item.id}
                      name="valor"
                      placeholder="ID / Nosso Número"
                      className="w-100"
                      errors={errors}
                      label="ID / Nosso Número"
                    />{" "}
                  </div>
                  <div className="col-md-6">
                    <NumberInput
                      control={form.control}
                      name={`value_id_${item.id}`}
                      label="Valor"
                      disabled={true}
                      defaultValue={item.value}
                      className="w-100"
                      errors={errors}
                      mode="currency"
                      currency="BRL"
                      locale="pt-br"
                      useGrouping={true}
                      placeholder={0}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                    />{" "}
                  </div>
                  <div className="col-md-6">
                    {" "}
                    <CalendarInput
                      disabled={true}
                      name={`due_date_id_${item.id}`}
                      inputId={`due_date_id_${item.id}`}
                      defaultValue={
                        item.due_date ? new Date(item.due_date) : null
                      }
                      isRequired={true}
                      control={form.control}
                      errors={errors}
                      label="Data de Vencimento"
                    />
                  </div>
                  <div className="col-md-6">
                    <CalendarInput
                      name={`payment_date_${item.id}`}
                      inputId={`payment_date_${item.id}`}
                      maxDate={new Date()}
                      defaultValue={
                        item.payment_date_
                          ? new Date(item.payment_date_)
                          : new Date()
                      }
                      onChange={(e) => {
                        const newValue = e.value
                          ? new Date(e.value)
                          : new Date();
                        handlePaymentDate(newValue, item);
                        setPaymentDates((prevDates) => ({
                          ...prevDates,
                          [item.id]: newValue,
                        }));
                      }}
                      isRequired={true}
                      control={form.control}
                      errors={errors}
                      label="Data de Pagamento"
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-xl-3 mt-2">
                    <NumberInput
                      control={form.control}
                      name={`discount_id_${item.id}`}
                      className="w-100"
                      defaultValue={item.discount}
                      errors={errors}
                      onChange={(e) => updateUpdatedValue(item)}
                      label="Desconto"
                      mode="currency"
                      currency="BRL"
                      locale="pt-br"
                      useGrouping={true}
                      placeholder={0}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                    />
                  </div>
                  <div className="col-md-6 col-xl-3 mt-2">
                    <NumberInput
                      control={form.control}
                      name={`add_id_${item.id}`}
                      className="w-100"
                      defaultValue={item.add}
                      errors={errors}
                      onChange={(e) => updateUpdatedValue(item)}
                      label="Acréscimos"
                      mode="currency"
                      currency="BRL"
                      locale="pt-br"
                      useGrouping={true}
                      placeholder={0}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                    />
                  </div>
                  <div className="col-md-6 col-xl-3 mt-2">
                    <NumberInput
                      control={form.control}
                      name={`updated_value_id_${item.id}`}
                      className="w-100"
                      disabled={true}
                      errors={errors}
                      required={true}
                      label="Valor Pago"
                      mode="currency"
                      currency="BRL"
                      locale="pt-br"
                      useGrouping={true}
                      placeholder={0}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                    />
                  </div>

                  <div className="col-md-6 col-xl-3 mt-4 pt-1">
                    <TextareaInput
                      name={`obs_id_${item.id}`}
                      rows={1}
                      label="Observações da parcela"
                      errors={errors}
                      control={form.control}
                    />
                  </div>
                </div>
                <div className="row mt-2 mb-3">
  <div className="col-md-6">
    <Select
      control={form.control}
      name={`payment_method_${item.id}`}
      errors={form.errors}
      options={paymentMethod}
      isRequired={true}
      disabled={loadingPaymentMethods}
      label={loadingPaymentMethods ? "Carregando..." : "Forma de Pagamento"}
    />
  </div>
  <div className="col-md-6">
    <Select
      control={form.control}
      errors={form.errors}
      isRequired={true}
      label={loadingCurrentAccount ? "Carregando..." : "Conta Corrente"}
      options={currentAccount}
      name={`current_account_${item.id}`}
    />
  </div>
</div>

<div className="row">
  <div className="col-md-12">
    <FileInput
      name="archive"
      base64={true}
      setSelectedFile={(file) => {
        // console.log("Arquivo selecionado:", file);
        setDocument(file);
      }}
      doc="Arquivo"
      icon="fa-file"
    />
  </div>
</div>

              </div>
            </Panel>
          ))}
        </div>

        <Panel mainCss="mt-3">
          <div className="alert alert-gray pt-3">
            <div className="row justify-content-start text-center">
              <div className="col-lg-2">
                <div className="d-flex flex-column">
                  <h5 className="mb-0">Qtd. Parcela:</h5>
                  <span className="mx-1 text-green fs-5">{sum}</span>
                </div>
              </div>
              <div className="col-lg-2">
                <div className="d-flex flex-column">
                  <h5 className="mb-0">Total Parcela:</h5>
                  <span className="mx-1 text-red fs-5">
                    {formatCurrency(totalParcel)}
                  </span>
                </div>
              </div>
              <div className="col-lg-2">
                <div className="d-flex flex-column">
                  <h5 className="mb-0">Total Desconto:</h5>
                  <span className="mx-1 text-gray fs-5">
                    {formatCurrency(totals.discount)}
                  </span>
                </div>
              </div>
              <div className="col-lg-2">
                <div className="d-flex flex-column">
                  <h5 className="mb-0">Total Acréscimos:</h5>
                  <span className="mx-1 text-gray fs-5">
                    {formatCurrency(totals.add)}
                  </span>
                </div>
              </div>
              <div className="col-lg-2">
                <div className="d-flex flex-column">
                  <h5 className="mb-0">Valor Total Pago:</h5>
                  <span className="mx-1 text-gray fs-5">
                    {formatCurrency(totals.updated_value)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center">
            <Button
              rounded
              loading={loading}
              type="submit"
              label="Confirmar Pagamento"
              icon="fa-solid fa-check"
              className="p-inputtext-sm m-auto"
            />
          </div>
        </Panel>
      </form>
    </div>
  );
};

export default DownloadParcelToPay;
